import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=21041865"
import script from "./Perfil.vue?vue&type=script&lang=js"
export * from "./Perfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21041865')) {
      api.createRecord('21041865', component.options)
    } else {
      api.reload('21041865', component.options)
    }
    module.hot.accept("./Perfil.vue?vue&type=template&id=21041865", function () {
      api.rerender('21041865', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/perfil/Perfil.vue"
export default component.exports